export default __webpack_public_path__ + "static/media/army_92.c1d75f76.jpg";